module.exports = __webpack_public_path__ + "static/media/05.50c5a5a7.jpg";